<script setup lang="ts">
const props = defineProps<{
  to: string;
}>();

const config = useRuntimeConfig();
const normalizePath = (path: string) => path.replace(/\/+$/, '');
const visible = computed(() =>
  normalizePath(config.public.previewDraftBlogPath) === normalizePath(props.to));
</script>

<template>
  <NuxtLink
    v-if="visible"
    :to="to"
  >
    <slot />
  </NuxtLink>
</template>
